// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2Qhm2";
export var message = "footer-module--message--3XbGJ";
export var links = "footer-module--links--8Oi5p";
export var linkSection = "footer-module--link-section--2tm1l";
export var smallerLinks = "footer-module--smaller-links--3sCEo";
export var copyright = "footer-module--copyright--BGQR-";